export type OrganizationSetting = {
  bankDocumentPreNotificationBeforeExpiration?: number
  bankDocumentFirstNotificationBeforeExpiration?: number
  bankDocumentLastNotificationBeforeExpiration?: number
  id?: number
  organizationId?: number
  monthlyReview: boolean
}
